import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as PricelistDetailActions from './pricelist-detail.action';
import { PricelistDetailService } from './pricelist-detail.service';
import { BannerService } from '../../shared/services/banner.service';
import * as PricelistDetailModels from '../../models/pricelist-detail/pricelist-detail';
import { PricelistDetailSearchModel } from '../../models/pricelist-detail/pricelist-detailSearch';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { SaveState } from '../../models/commonModels';
import { saveAs } from 'file-saver';

export interface PricelistDetailStateModel {
    PricelistDetail: PricelistDetailModels.PricelistDetailModel;
    Save: SaveState;
    Delete: SaveState;
    Search: PricelistDetailSearchModel;
    List: PricelistDetailModels.PricelistDetailListModel;
    ImportLoading: boolean;
    ImportResponse: PricelistDetailModels.PricelistDetailImportResponse;
  }

@State<PricelistDetailStateModel>({
    name: 'pricelistDetailState',
    defaults: {
      PricelistDetail: null,
      Save: null,
      Search: null,
      List: null,
      Delete: null,
      ImportLoading: false,
      ImportResponse: null
    }
  })

  @Injectable()

  export class PricelistDetailState {

    constructor(
                private helperService: HelperService,
                private pricelistDetailService: PricelistDetailService,
                private bannerService: BannerService
    ) { }


  @Selector()
  static ImportLoading(state: PricelistDetailStateModel) {
    return state.ImportLoading;
  }


  @Selector()
  static ImportResponse(state: PricelistDetailStateModel) {
    return state.ImportResponse;
  }


  @Selector()
  static List(state: PricelistDetailStateModel) {
    return state.List;
  }

  @Selector()
  static PricelistDetail(state: PricelistDetailStateModel) {
    return state.PricelistDetail;
  }

  @Selector()
  static Save(state: PricelistDetailStateModel) {
    return state.Save;
  }

  @Selector()
  static Delete(state: PricelistDetailStateModel) {
    return state.Delete;
  }

  @Selector()
  static Search(state: PricelistDetailStateModel) {
    return state.Search;
  }


  @Action(PricelistDetailActions.SetSearch)
  setSearch(
    context: StateContext<PricelistDetailStateModel>,
    action: PricelistDetailActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new PricelistDetailActions.GetList(action.Search));
  }

  @Action(PricelistDetailActions.SetListPage)
  setListPage(
    context: StateContext<PricelistDetailStateModel>,
    action: PricelistDetailActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new PricelistDetailActions.GetList(action.Search));
  }

  @Action(PricelistDetailActions.ResetSearch)
  resetSearch(
    context: StateContext<PricelistDetailStateModel>
  ) {

    const s = context.getState();

    const search = new PricelistDetailSearchModel();

    search.ItemsPerPage = s.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new PricelistDetailActions.GetList(search));
  }

  @Action(PricelistDetailActions.GetList)
  getList(
    context: StateContext<PricelistDetailStateModel>,
    action: PricelistDetailActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania cennika.';

    context.setState(
      patch({
        List: null
      })
    );

    if (action.Search.PricelistId) {
        this.pricelistDetailService.get(action.Search).subscribe((ret) => {
          if (ret.Success) {
            context.setState(
              patch({
                List: ret
              })
            );
            return ret;
            } else {
              this.bannerService.error(ret.Message, errorMessage);
            }
          },
          (error) => {
            this.helperService.SaveException('PricelistDetailActions.GetList', error);
            // this.bannerService.error(errorMessage);
        });
    }

  }


  @Action(PricelistDetailActions.Insert)
  insert(
    context: StateContext<PricelistDetailStateModel>,
    action: PricelistDetailActions.Insert
  ) {
    const errorMessage = 'Błąd zapisu nowego elementu cennika.';

    this.pricelistDetailService.insertNew(action.PricelistNewDetail).subscribe(
      ret => {
        this.bannerService.success('Dodano oponę do cennika.');

        context.setState(
          patch({
            Save: new SaveState(action.PricelistNewDetail.PriceListId, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            Save: new SaveState(action.PricelistNewDetail.PriceListId, false)
          })
        );


        this.helperService.SaveException('PricelistDetailActions.Insert', error);

        this.bannerService.error(`${errorMessage} ${error}`);
      },
      () => {});
  }


  @Action(PricelistDetailActions.ResetSave)
  resetSave(
    context: StateContext<PricelistDetailStateModel>,
  ) {
    context.setState(
      patch({
        Save: null
      })
    );
  }

  @Action(PricelistDetailActions.Set)
  setPricelistDetail(
    context: StateContext<PricelistDetailStateModel>,
    action: PricelistDetailActions.Set
  ) {
    const errorMessage = 'Błąd zapisu elementu cennika.';

    this.pricelistDetailService.setPricelistDetail(action.PricelistDetail).subscribe(
      ret => {
        this.bannerService.success('Zmiany elementu cennika zapisane.');

        context.setState(
          patch({
            Save: new SaveState(action.PricelistDetail.TyreId, true)
          })
        );
      },

      (error) => {

        context.setState(
          patch({
            Save: new SaveState(action.PricelistDetail.TyreId, false)
          })
        );


        this.helperService.SaveException('PricelistDetailActions.SetPricelistDetail', error);

        this.bannerService.error(errorMessage);
      },
      () => {});
  }


  @Action(PricelistDetailActions.Delete)
  deletePricelistDetail(
    context: StateContext<PricelistDetailStateModel>,
    action: PricelistDetailActions.Set
  ) {
    const errorMessage = 'Błąd podczas usuwania elementu cennika.';

    this.pricelistDetailService.deletePricelistDetail(action.PricelistDetail).subscribe(
      ret => {
        this.bannerService.success('Element cennika został usunięty.');

        context.setState(
          patch({
            Delete: new SaveState(action.PricelistDetail.TyreId, true)
          })
        );
      },

      (error) => {

        context.setState(
          patch({
            Delete: new SaveState(action.PricelistDetail.TyreId, false)
          })
        );


        this.helperService.SaveException('PricelistDetailActions.SetPricelistDetail', error);

        this.bannerService.error(errorMessage);
      },
      () => {});
  }

  @Action(PricelistDetailActions.ImportPricelist)
  importPricelist(
      context: StateContext<PricelistDetailStateModel>,
      action: PricelistDetailActions.ImportPricelist
    ) {
        context.getState();

        function patchLoading( b: boolean) {
          context.setState(
            patch ({
              ImportLoading: b,
            })
          );
        }

        function patchImportResponse(r: PricelistDetailModels.PricelistDetailImportResponse) {
          context.setState(
            patch ({
              ImportResponse: r,
            })
          );
        }

        patchLoading(true);
        const errorMessage = 'Błąd importu cennika.';
        this.pricelistDetailService.importPricelist(action.formData).subscribe( ret => {
            if (ret && ret.ImproperData) {
              patchImportResponse(ret);
            }

            if (ret.Success) {
              this.bannerService.success('Zaimportowano cennik.');
              patchLoading(false);
            } else {
              patchLoading(false);
              if (ret.ImproperData && ret.ImproperData.length > 0) {
                /*ret.ImproperData.forEach((d) => {
                  this.bannerService.error(`${d.Name} - ${d.Description}; `);
                });*/
                this.bannerService.error(errorMessage);
              }
              this.helperService.SaveException('PricelistDetailActions.ImportPricelist', errorMessage);
            }
          }
        );
  }

  @Action(PricelistDetailActions.DisposeSearch)
  disposeSearch(
      context: StateContext<PricelistDetailStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(PricelistDetailActions.ImportResponseDispose)
  importResponseDispose(
      context: StateContext<PricelistDetailStateModel>
    ) {

      context.setState(
        patch({
          ImportResponse: null
        }));
  }
}

